const zIndex = {
    invisible: -1 /* Invisible elements */,
    element: 1 /* Elements and Components */,
    navigation: 10 /* navigation */,
    overlay: 100 /* overlays, modals, dialogs */,
};

export default zIndex;
